
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 56","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.933 9.112L21.193.092a1.007 1.007 0 00-.84 0L.595 9.112A1.018 1.018 0 000 10.04v19.95c0 .175.158 4.484 2.767 9.861 2.382 4.94 7.374 11.718 17.603 16.061.123.053.263.088.403.088s.28-.035.403-.088c19.599-8.337 20.352-25.747 20.37-25.957V10.041a1.066 1.066 0 00-.613-.929zm-20.16 44.751C2.785 46.016 2.067 30.586 2.049 29.955V10.706L20.773 2.16l18.723 8.547v19.232c-.035.648-.753 16.078-18.723 23.925z"}}),_c('path',{attrs:{"d":"M37.184 12.353L21.193 5.049a1.007 1.007 0 00-.84 0l-16.01 7.304a1 1 0 00-.595.928v16.167c0 .14.14 3.678 2.26 8.074 1.944 4.028 6.025 9.563 14.362 13.119.122.052.263.087.403.087s.28-.035.402-.087c15.992-6.796 16.622-21.036 16.622-21.211V13.28a1.066 1.066 0 00-.613-.928zm-3.538 24.363c-2.557 5.237-6.9 9.23-12.873 11.858-5.99-2.627-10.317-6.62-12.874-11.858-1.962-4.01-2.102-7.304-2.102-7.304V13.947l14.976-6.849 14.957 6.849v15.448c0 .017-.122 3.31-2.084 7.321z"}}),_c('path',{attrs:{"d":"M20.772 16.172c-6.287 0-11.402 5.114-11.402 11.402 0 6.288 5.115 11.402 11.402 11.402 6.288 0 11.403-5.114 11.403-11.402 0-6.288-5.115-11.402-11.403-11.402zm0 20.773c-5.166 0-9.353-4.204-9.353-9.353 0-5.15 4.204-9.353 9.353-9.353 5.15 0 9.354 4.203 9.354 9.353 0 5.15-4.204 9.353-9.354 9.353z"}}),_c('path',{attrs:{"d":"M25.396 23.282l-6.953 6.954-3.03-2.96a1.02 1.02 0 00-1.436.017 1.005 1.005 0 00.017 1.437l3.748 3.66c.193.193.456.298.718.298.263 0 .526-.105.719-.298l7.654-7.654a1.005 1.005 0 000-1.436.99.99 0 00-1.437-.018z"}})])
          )
        }
      }
    